import React from 'react';

import { cssMap } from '@atlaskit/css';
import Tag from '@atlaskit/tag/tag';
import TagGroup from '@atlaskit/tag-group/tag-group';
import { token } from '@atlaskit/tokens';

import { getLabelUrl } from '../utils/blogPostDataUtils.ts';

type BlogPostLabelsListProps = {
	labels: string[];
	spaceKey?: string | null;
};

const styles = cssMap({
	labelsContainer: {
		paddingBlockStart: token('space.100'),
	},
});

export const LabelsList = ({ labels, spaceKey }: BlogPostLabelsListProps): React.JSX.Element => (
	<div css={styles.labelsContainer} data-testid="blog-post-labels">
		<TagGroup>
			{labels.map((label) => (
				<Tag
					key={label}
					text={label}
					href={getLabelUrl(label, spaceKey)}
					color="standard"
					testId="blog-post-label"
					isRemovable={false}
				/>
			))}
		</TagGroup>
	</div>
);
